export default __webpack_public_path__ + "static/media/wrong.3247fb73.svg";